var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.required)?_c('span',{staticClass:"cfw-required",attrs:{"title":"This field is required","aria-label":"This field is required"}},[_vm._v("*")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }